export function getAgentSearchRedirect(searchTerm: string) {
  return `/jobs/performers/search/${searchTerm}`;
}
